module.exports = __webpack_public_path__ + "static/media/tokutei.15a93385.md";